// Import the centralized trade definitions
import { getTradeLabelsRecord } from '../../ApiLib';

// Use the centralized trade definitions instead of duplicating them
export const ContractorTradeLabels: Record<string, string> = getTradeLabelsRecord();
